module.exports = __webpack_public_path__ + "static/media/14_l_tkan2_8.9171.48.b9d79af0.png";